export function getNotifications (state) {
  return state.notifications
}
